import supabase from "../lib/supabaesClient";
import { ApiResponse } from "../models/apiResponse";
import { TokenResult } from "../models/token";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import { analytics } from "../lib/firebaseConfig"; // firebaseConfig.ts에서 초기화된 analytics 객체를 가져옵니다.

export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

// 세션 확인 함수
export const checkSession = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession(); // 세션 확인
  return session;
};

// 로그아웃 함수
export const logout = async () => {
  try {
    await supabase.auth.signOut(); // Supabase 로그아웃
    // 추가적인 로직이 필요하면 여기에 작성 (예: localStorage에서 토큰 제거)
  } catch (error: any) {
    throw new Error(error.message || "An error occurred while logging out");
  }
};

// Firebase Analytics에 사용자 정보 설정
export const setFirebaseUserProperties = (user: any) => {
  // Firebase Analytics에서 유저 속성 설정
  setUserProperties(analytics, {
    user_id: user.id, // 유저의 ID
    email: user.email, // 유저의 이메일
  });

  // 추가적으로 사용자의 다른 정보를 설정할 수 있습니다
  logEvent(analytics, "user_login", {
    user_id: user.id,
    email: user.email,
  });
};

// 토큰 데이터 가져오는 함수
export const fetchTokenData = async (): Promise<ApiResponse<TokenResult>> => {
  try {
    const session = await checkSession(); // 세션을 가져옵니다.
    const accessToken = session?.access_token; // 액세스 토큰을 가져옵니다

    if (!accessToken) {
      throw new Error("No access token found");
    }

    const response = await fetch(`${apiBaseUrl}/admin/v1/token`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Authorization 헤더에 액세스 토큰 추가
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch token data");
    }

    const data: ApiResponse<TokenResult> = await response.json();
    return data; // ApiResponse 형식으로 데이터 반환
  } catch (error: any) {
    throw new Error(
      error.message || "An error occurred while fetching token data"
    );
  }
};

// 로그인 후 Firebase Analytics에 사용자 정보 추가
export const handleAuthStateChange = async (session: any) => {
  if (session) {
    // 로그인 상태일 경우 Firebase에 사용자 정보 설정
    const user = session.user;
    setFirebaseUserProperties(user); // Firebase에 사용자 정보 전달
  }
};

// 로그인 상태가 변경될 때마다 호출되는 함수
supabase.auth.onAuthStateChange(async (_, session) => {
  handleAuthStateChange(session);
});
